import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';

import { AUTH_STATUSES } from 'app/utils/constants';

import PageLoading from 'app/components/common/PageLoading';

import ErrorBoundary from 'app/components/common/ErrorBoundary';

const SignInRequiredRoute = ({
  component: Component,
  isAuthenticated,
  authStatus,
  platform,
  ...rest
}) => {
  const render = (props) => {
    const { pathname, search } = props.location; // eslint-disable-line
    const next = `${pathname}${search}`;
    const encodedNext = encodeURIComponent(next);

    if (authStatus === AUTH_STATUSES.LOADING) {
      return <PageLoading />;
    }

    if (isAuthenticated) {
      return (
        <ErrorBoundary platform={platform}>
          <Component {...props} />
        </ErrorBoundary>
      );
    }

    return <Redirect to={`/signin?next=${encodedNext}`} />;
  };
  return <Route {...rest} render={render} />;
};

SignInRequiredRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  authStatus: PropTypes.number.isRequired,
  platform: PropTypes.string,
};

SignInRequiredRoute.defaultProps = {
  platform: null,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.common.user.isLoaded,
  authStatus: state.common.authStatus,
  platform: state.common.platform,
});
const connector = connect(mapStateToProps);

export default connector(SignInRequiredRoute);



// WEBPACK FOOTER //
// ./src/app/components/routes/SignInRequiredRoute/index.jsx